$(document).ready ->
  if $('a.mail').length
    for el in $('.mail')
      email = el.innerText.replace(/\&/g,'.').replace(/\|/g,'@')
      el.innerHTML = email
      el.href = "mailto:#{email}"
